import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  azureOauthUrl = '/api/eon-iot/authorize?redirect='
  rolesUrl = '/api/admin/login/roles'
  logoutUrl = '/api/logout/start?redirect='

  constructor(private http: HttpClient) {
  }

  startAzureOauth() {
    location.href = this.azureOauthUrl + location.href
  }

  startLogout() {
    location.href = this.logoutUrl + location.href
  }

  getRoles(): Observable<string> {
    return this.http.get<string>(this.rolesUrl)
  }

}
